<template>
  <v-row dense>
    <v-col cols="12">
      <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'" elevation="0"
        class="all-trade-tab rounded-0">
        <v-tabs :background-color="$vuetify.theme.dark ? 'blue-darken-2' : 'white-lighten-2'
          " v-model="model">
          <v-tab class="ml-0" v-if="hasRegUserAccess" :href="`#tab-1`">
            <!-- Registered User <strong>18</strong> -->
            Registered User
          </v-tab>
          <v-tab v-if="hasDocAccess" :href="`#tab-2`"> Documents </v-tab>
          <v-tab v-if="hasLiveAccAccess" :href="`#tab-3`"> Live Accounts </v-tab>
          <v-tab v-if="hasDemoAccAccess" :href="`#tab-4`"> Demo Accounts </v-tab>
          <v-tab v-if="hasTestAccAccess" :href="`#tab-8`"> Testing Accounts </v-tab>
          <v-tab v-if="hasBlockUserAccess" :href="`#tab-5`"> Blocked User </v-tab>
           <v-tab v-if="hasInactiveAccAccAccess" :href="`#tab-6`"> Inactive Acc. </v-tab>
          <!-- <v-tab v-if="hasBlockLowBalanceAccAccess" :href="`#tab-7`"> Low Balance Acc. </v-tab> -->
          <v-tabs-items v-model="model">
            <v-tab-item :value="`tab-1`">
              <v-card flat>
                <RegisteredUserTab></RegisteredUserTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-2`">
              <v-card flat>
                <DocumentTab></DocumentTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-3`">
              <v-card flat>
                <LiveAccountsTab></LiveAccountsTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-4`">
              <v-card flat>
                <DemoAccountsTab></DemoAccountsTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-8`">
              <v-card flat>
                <TestingAccountsTab></TestingAccountsTab>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="`tab-5`">
              <v-card flat>
                <BlockedUserTab></BlockedUserTab>
              </v-card>
            </v-tab-item>
             <v-tab-item :value="`tab-6`">
              <v-card flat>
                <InactiveAccountTab></InactiveAccountTab>
              </v-card>
            </v-tab-item>
            <!-- <v-tab-item :value="`tab-7`">
              <v-card flat>
                <LowBalanceAccountTab></LowBalanceAccountTab>
              </v-card>
            </v-tab-item> -->
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

import BlockedUserTab from "@/components/RegisteredUser/BlockedUser.vue";
import DemoAccountsTab from "@/components/RegisteredUser/DemoAccounts.vue";
import TestingAccountsTab from "@/components/RegisteredUser/TestingAccounts.vue";
import DocumentTab from "@/components/RegisteredUser/DocumentTab.vue";
import InactiveAccountTab from "@/components/RegisteredUser/InactiveAccountTab.vue";
import LiveAccountsTab from "@/components/RegisteredUser/LiveAccounts.vue";
import LowBalanceAccountTab from "@/components/RegisteredUser/LowBalanceAccountTab.vue";
import RegisteredUserTab from "@/components/RegisteredUser/RegisteredUserTab.vue";
export default {
  components: {
    RegisteredUserTab,
    DocumentTab,
    LiveAccountsTab,
    DemoAccountsTab,
    BlockedUserTab,
    InactiveAccountTab,
    LowBalanceAccountTab,
    TestingAccountsTab
  },
  
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },

  watch: {
    model: function (newModel) {
      const tab = newModel.split("-")[1];
      const currentQuery = { ...this.$route.query };
      if (tab && currentQuery.tab !== tab) {
        currentQuery.tab = tab;
        this.$router.push({
          path: this.$route.path,
          query: currentQuery,
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    "$route.query.tab": function (newTab) {
      if (newTab) {
        this.model = `tab-${newTab}`;
      } else {
        this.$router.push({
          path: this.$route.path,
          query: { tab: 1 },
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
  },

  computed: {
    ...mapState("admins", ["loggedAdmin"]),
    hasRegUserAccess() {
      return this.$canRoute('registered-user?tab=1') > 0;
    },
    hasDocAccess() {
      return this.$canRoute('registered-user?tab=2') > 0;
    },
    hasLiveAccAccess() {
      return this.$canRoute('registered-user?tab=3') > 0;
    },
    hasDemoAccAccess() {
      return this.$canRoute('registered-user?tab=4') > 0;
    },
    hasBlockUserAccess() {
      return this.$canRoute('registered-user?tab=5') > 0;
    },
    hasInactiveAccAccAccess() {
      return this.$canRoute('registered-user?tab=6') > 0;
    },
    hasBlockLowBalanceAccAccess() {
      return this.$canRoute('registered-user?tab=7') > 0;
    },
    hasTestAccAccess() {
      return this.$canRoute('registered-user?tab=8') > 0;
    },
  },

  mounted() {
    if (this.$route.query.tab) {
      this.model = `tab-${this.$route.query.tab}`;
    }
  },
};
</script>
